<template>
    <div>

        <div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"		
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Welcome to RISE" /></h1>
				<span><LanguagePlaceholder default-text="Elevate your rewards with every purchase" /></span>
			</div>			
		</div>
        <div class="d-flex justify-center align-center w-100 position-relative">
            <div class="bg-color-quartz w-100 h-100">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-1 bg-color-teal-900 tx-color-white">
                <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                    <!-- <v-row no-gutters>
                        <LanguagePlaceholder class="text-h4" default-text='Welcome to the RISE incentive program from Dell Technologies.' />
                    </v-row> -->
                    <v-row no-gutters class="text-body-3 my-2">
                        <LanguagePlaceholder default-text='This portal contains the information and assets you need to drive incremental business through Dell Technologies Authorized Partners.' />
                    </v-row>
                    <v-row no-gutters class="text-body-3 my-2">
                        <LanguagePlaceholder default-text='Sales data is loaded two weeks in arrears. Information such as the number of partners that purchase from you who are signed up to RISE will show after Week Two of the incentive period (when sales data is loaded).' />
                    </v-row>             
                </v-col>
                </v-row>
            </div>
		</div>
        <v-container class="pa-0 mt-3" fluid>

            
            <v-row justify="center">
                        
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <!-- <v-container class="pb-0 bg-color-teal-700">
                        <v-sheet class="my-2 text-h4 font-weight-light bg-color-teal-700">
                            <h1 style="color: white; font-weight: 300;" class="text-h4 bg-color-teal-700"><LanguagePlaceholder default-text="Welcome to the RISE incentive program from Dell Technologies." /></h1>
                        </v-sheet>
                        <v-sheet class="my-2 text-body-2 font-weight-light bg-color-teal-700" style="color: white;">
                            <LanguagePlaceholder default-text="This portal contains the information and assets you need to drive incremental business through Dell Technologies' Authorized Partners." />
                        </v-sheet>
                        <v-sheet class="text-body-2 font-weight-light font-italic bg-color-teal-700" style="color: white;">
                            <LanguagePlaceholder default-text="Sales data is loaded two weeks in arrears. Information such as the number of partners that purchase from you who are signed up to RISE will show after Week Two of the incentive period (when sales data is loaded)." />
                        </v-sheet>
                    </v-container> -->
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
            <v-row class="mt-5" no-gutters="" justify="center">
                <v-col cols="12" sm="4" md="6">
                    <div>
                        <v-select v-model="selectedQuarter" :items="quarters"
                            @update:modelValue="changeQuarter"
                            variant="outlined"
                            aria-label="Select Incentive Period">
                            <template v-slot:label>
                                <LanguagePlaceholder default-text="Select Incentive Period" />
                            </template>
                        </v-select>        
                    </div>
                    <div v-if="showCountryAndDistributorSelection">
                        <v-switch 
                            v-model="selectAll"
                            @update:modelValue="selectionChangeAll"
                            color="primary"
                            density="compact">
                            <template v-slot:label>
                                <LanguagePlaceholder default-text="Select All Distributors in All Locations" />
                            </template>
                        </v-switch>
                        <div v-if="!selectAll">
                            <div class="d-flex ga-5">
                                <v-switch 
                                    v-model="selectDistributorByRegion"
                                    @update:modelValue="selectionChangeDistributorByRegion"
                                    color="primary"
                                    density="compact">
                                </v-switch>
                                <v-select clearable :items="regions"
                                    return-object v-model="selectedRegion"
                                    variant="outlined"
                                    aria-label="Select Region"
                                    :disabled="!selectDistributorByRegion">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select All Distributors by Region" />
                                    </template>
                                </v-select> 
                            </div>
                            <div class="d-flex ga-5">
                                <v-switch 
                                    v-model="selectDistributorByCountry"
                                    @update:modelValue="selectionChangeDistributorByCountry"
                                    color="primary"
                                    density="compact">
                                </v-switch>
                                <v-select clearable :items="countries"
                                    return-object v-model="selectedCountry"
                                    @update:modelValue="changeCountry" item-title="country" item-value="country"
                                    variant="outlined"
                                    aria-label="Select Location"
                                    :disabled="!selectDistributorByCountry">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributors by Location" />
                                    </template>
                                </v-select> 
                                <v-select
                                    clearable
                                    v-model="selectedDistributor" return-object
                                    item-title="distributorName"
                                    item-value="distiId" :items="distributors" variant="outlined"
                                    aria-label="Select Distributor"
                                    :disabled="!selectDistributorByCountry">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributor" />
                                    </template>
                                </v-select> 
                            </div> 
                            <div class="d-flex ga-5">
                                <v-switch 
                                    v-model="selectMasterDistributor"
                                    @update:modelValue="selectionChangeMasterDistributor"
                                    color="primary"
                                    density="compact">
                                </v-switch>
                                <v-select
                                    clearable
                                    v-model="selectedMasterDistributor" return-object
                                    item-title="distributorName"
                                    item-value="distributorName" :items="masterDistributors" variant="outlined"
                                    aria-label="Select Distributor in All Locations"
                                    :disabled="!selectMasterDistributor">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributor in All Locations" />
                                    </template>
                                </v-select> 
                            </div>                                
                        </div>                        
                    </div>
                </v-col>
            </v-row>
            <v-row  no-gutters="" justify="center"> 
                <div>
                    <v-btn @click="getData"
                        variant="outlined"><LanguagePlaceholder default-text="Submit" />
                    </v-btn>
                </div>
            </v-row>
            <v-row justtify="center">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-container class="pt-0">
                        <div v-for="o, idx in dashboardItems" class="animate__animated animate__fadeInBottomLeft animate__faster">
                            <v-sheet class="my-2 text-body-2 font-weight-bold" color="transparent" style="color: white;">
                                <h2 style="color: #000c30; font-weight: 300;" class="text-h5"><LanguagePlaceholder :default-text="o.category" /></h2>
                            </v-sheet>
                            <v-row>
                                <v-col cols="12" sm="12" md="4"  v-for="oItm, idxItm in o.items">
                                    <v-card tile :color="oItm.bgColor" style="height: 150px;" >
                                        <v-card-text class="ma-3 pa-0">
                                            <v-sheet class="my-2 text-body-2 font-weight-regular" color="transparent"
                                                style="color: white;" height="40">
                                                <h3><LanguagePlaceholder :default-text="oItm.header" /></h3>
                                            </v-sheet>
                                            <v-sheet v-if="oItm.isCurrency === true" class="my-2 text-h5 font-weight-bold" color="transparent"
                                                style="color: white;">
                                                {{ $filters.currencyUSD(oItm.value) }}
                                            </v-sheet>
                                            <v-sheet v-if="oItm.isNumber === true" class="my-2 text-h5 font-weight-bold" color="transparent"
                                                style="color: white;">
                                                {{ $filters.formattedNumber(oItm.value) }}
                                            </v-sheet>
                                            <v-btn 
                                            class="text-none" 
                                            style="color: black; position: absolute; bottom: 5px; width: 93%;" 
                                            @click="oItm.clickEvent">
                                                <LanguagePlaceholder :default-text="oItm.buttonText" />
                                                </v-btn>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>                        
                    </v-container>
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
        </v-container>
    </div>

</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useExcelStore } from '@/stores/excel'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()
const excelStore = useExcelStore()

const timeout = 3000;

const dashboardItems = ref([])
const reportData = ref({})

const quarters = ref([])
const selectedQuarter = ref('')

const countries = ref([])
const selectedCountry = ref('')

const regions = ref([])
const selectedRegion = ref('')

const distributors = ref([])
const selectedDistributor = ref('')

const masterDistributors = ref([])
const selectedMasterDistributor = ref('')
const selectMasterDistributor = ref(false)

const showCountryAndDistributorSelection = ref(false)
const selectAll = ref(false)
const selectDistributorByCountry = ref(false)
const selectDistributorByRegion = ref(false)

const selectionChangeAll = () => {
    if (selectAll.value === true) {
        selectDistributorByCountry.value = false
        selectDistributorByRegion.value = false
        selectMasterDistributor.value = false
        
        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectDistributorByCountry.value === false && selectDistributorByRegion.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const newsArticlesDisti = ref([
      { backgroundColor: "#84133f", heading: 'Find out what\'s new in RISE!'
      , subHeading: 'Sign up for the Webinar!'
      , pictureUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEDistiWebinar.jpg'
      , readMoreContentUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEDistiWebinar.html', clickEvent: undefined },
])

const clickReadMore = (o) => {
    if (o.clickEvent !== undefined) {
        o.clickEvent()
    } else {
        systemStore.openUrl(o.readMoreContentUrl)
    }
}

const selectionChangeDistributorByCountry = () => {
    if (selectDistributorByCountry.value === true) {
        selectAll.value = false
        selectDistributorByRegion.value = false
        selectMasterDistributor.value = false
       
        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectAll.value === false && selectDistributorByRegion.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const selectionChangeMasterDistributor = () => {
    if (selectMasterDistributor.value === true) {
        selectAll.value = false
        selectDistributorByRegion.value = false
        selectDistributorByCountry.value = false

        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectAll.value === false && selectDistributorByRegion.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const selectionChangeDistributorByRegion = () => {
    if (selectDistributorByRegion.value === true) {
        selectAll.value = false
        selectDistributorByCountry.value = false
        selectMasterDistributor.value = false
        
        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectDistributorByCountry.value === false && selectAll.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const changeQuarter = () => {
    selectedDistributor.value = ''
    selectedCountry.value = ''
    selectedRegion.value = ''
    selectedMasterDistributor.value = ''
}

const changeCountry = () => {
    selectedDistributor.value = ''

    if (selectedCountry.value === null || selectedCountry.value === '') {
        return
    }
    systemStore.getPartnerPerformanceDistributors(selectedQuarter.value, selectedCountry.value).then(result => {
        distributors.value = result.responseData

        if (distributors.value.length === 1) {
            selectedDistributor.value = distributors.value[0]
        }
    }).catch(error => {
        console.log(error)
    })
}

onMounted(() => {
    if (systemStore.userDetail.userType.trim() === 'TIC_Admin' || 
        systemStore.userDetail.userType.trim() === 'Dell Marketing') {
        showCountryAndDistributorSelection.value = true
        selectDistributorByCountry.value = true
    }

    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentQuarter === true || q.currentRedemptionQuarter === true)
                .map(q => q.quarter)

            selectedQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter

            if (showCountryAndDistributorSelection.value === true) {
                systemStore.getPartnerPerformanceCountries(selectedQuarter.value).then(result => {
                    countries.value = result.responseData
                    selectedCountry.value = ''
                })        

                systemStore.getPartnerPerformanceRegions().then(result => {
                    regions.value = result.responseData
                    selectedCountry.value = ''
                })    

                systemStore.getPartnerPerformanceMasterDistributors().then(result => {
                    masterDistributors.value = result.responseData
                })

            }
            else {
                getData()
            }            
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })    

})

const getData = () => {
    if (showCountryAndDistributorSelection.value === true) { 
        if (selectDistributorByCountry.value === true) {
            selectedRegion.value = ''
            selectedMasterDistributor.value = ''
            if (selectedCountry.value === '') {
                systemStore.showMessage('Select a Location and/or Distributor', { timeout: timeout, color: 'info' })
                return
            }
            if (selectedDistributor.value === null) {
                selectedDistributor.value = ''
            }
        } else if (selectDistributorByRegion.value === true) {
            selectedCountry.value = ''
            selectedDistributor.value = ''
            selectedMasterDistributor.value = ''
            if (selectedRegion.value === '') {
                systemStore.showMessage('Select a Region', { timeout: timeout, color: 'info' })
                return
            }
        } else if (selectMasterDistributor.value === true) {
            selectedCountry.value = ''
            selectedDistributor.value = ''
            selectedRegion.value = ''
            if (selectedMasterDistributor.value === '') {
                systemStore.showMessage('Select a Distributor', { timeout: timeout, color: 'info' })
                return
            }
        } else if (selectAll.value === true) {
            selectedCountry.value = ''
            selectedDistributor.value = ''
            selectedRegion.value = ''
            selectedMasterDistributor.value = ''
        }
        else {
            if (selectedCountry.value === '') {
                systemStore.showMessage('Select a Location and/or Distributor', { timeout: timeout, color: 'info' })
                return
            }
        }
    }
    else {
        selectedCountry.value = ''
        selectedDistributor.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }   

    systemStore.getDistributorHomeDashboard(selectedQuarter.value
        , selectedCountry.value
        , selectedDistributor.value === '' ? 0 : selectedDistributor.value.distiId
        , selectedRegion.value
        , selectedMasterDistributor.value).then(result => {
        reportData.value = result.responseData

        var onboarding = {'category': 'RISE Onboarding', items: []}

        onboarding.items.push({header: 'Your partners buying eligible products', bgColor: '#004D40', value: reportData.value.partnersBuyingEligibleProducts, isCurrency: false, isNumber: true, buttonText: 'Show Partner Performance', clickEvent: showPartnerPerformance})
        onboarding.items.push({header: 'Your partners signed up to RISE', bgColor: '#00796B', value: reportData.value.partnersSignedUpToRiseCount, isCurrency: false, isNumber: true, buttonText: 'Show Partners IN RISE', clickEvent: showPartnerInRise})
        onboarding.items.push({header: 'Your partners not signed up to RISE', bgColor: '#EEEEEE', value: reportData.value.partnersNotSignedUpToRiseCount, isCurrency: false, isNumber: true,  buttonText: 'Show Partners OUT of RISE', clickEvent: showPartnerOutOfRise})
        
        var riseEarnings = {'category': 'RISE Earnings', items: []}

        riseEarnings.items.push( {header: "Your partners' earnings this period", bgColor: "#004D40", value: reportData.value.partnersEarningsThisPeriod, isCurrency: true, buttonText: "Show Partner Performance", clickEvent: showPartnerPerformance})
        riseEarnings.items.push({header: "Your partners' earnings last period", bgColor: "#00796B", value: reportData.value.partnersEarningsLastPeriod, isCurrency: true, buttonText: "Show Partner Performance", clickEvent: showPartnerPerformance})
        riseEarnings.items.push({header: "Eligible partners' bonus reward value", bgColor: "#EEEEEE", value: reportData.value.partnerBonus, isCurrency: true, buttonText: "Show Bonus Dashboard", clickEvent: ShowBonusDashboard})

        var evouchers = {'category': 'E-Vouchers', items: []}

        evouchers.items.push({header: "Your partners with $ to redeem for e-vouchers", bgColor: "#004D40", value: reportData.value.partnersWithDollarRewardsToRedeemForEVouchers, isCurrency: false, buttonText: "Show Partner Performance", clickEvent: showPartnerPerformance})
        evouchers.items.push({header: "Your partners with e-vouchers to spend", bgColor: "#00796B", value: reportData.value.partnersWithEVouchersToSpend, isCurrency: false, buttonText: "Show E-Voucher Report", clickEvent: showEVoucherReport})
        evouchers.items.push({header: "Value of e-vouchers remaining to spend", bgColor: "#EEEEEE", value: reportData.value.valueOfEVouchersRemainingToSpend, isCurrency: true, buttonText: "Show E-Voucher Report", clickEvent: showEVoucherReport})

        var creditnotes = {'category': 'Credit Notes', items: []}

        creditnotes.items.push({header: "Your partners with credit notes to spend", bgColor: "#004D40", value: reportData.value.partnersWithCreditNotesToSpend, isCurrency: false, buttonText: "Show Credit Note Report", clickEvent: showCreditNoteReport})
        creditnotes.items.push({header: "Value of credit notes remaining to spend", bgColor: "#00796B", value: reportData.value.valueOfCreditNotesRemainingToSpend, isCurrency: true, buttonText: "Show Credit Note Report", clickEvent: showCreditNoteReport})

        dashboardItems.value = []
        dashboardItems.value.push(onboarding)
        dashboardItems.value.push(riseEarnings)
        dashboardItems.value.push(evouchers)
        dashboardItems.value.push(creditnotes)

    })
}

const downloadPartnersOutOfRiseFile = () => {
    if (reportData.value.length === 0) {
        return
    }
    
    excelStore.generateInMemoryExcelDocument(reportData.value.partnersNotSignedUpToRise, 'DistributorOutOfRisePartners').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorOutOfRisePartners', error)
    })
}

const downloadPartnersInRiseFile = () => {
    if (reportData.value.length === 0) {
        return
    }
    
    excelStore.generateInMemoryExcelDocument(reportData.value.partnersSignedUpToRise, 'DistributorInRisePartners').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorInRisePartners', error)
    })
}

const showPartnerPerformance = () => {
    systemStore.routerTo('partner-performance')
}

const ShowBonusDashboard = () => {
    systemStore.routerTo('bonus-dashboard-distributor')
}

const showPartnerInRise = () => {
    downloadPartnersInRiseFile()
}

const showPartnerOutOfRise = () => {
    downloadPartnersOutOfRiseFile()
}

const showEVoucherReport = () => {
    systemStore.routerTo('distributor-evoucher-report')
}
const showCreditNoteReport = () => {
    systemStore.routerTo('creditnote-report')
}


</script>